"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactUsContentPageDictionary = void 0;
exports.contactUsContentPageDictionary = {
    genericErrorMessage: 'Generic Error Message',
    submitSuccessMessage: 'SubmitSuccessMessage',
    submitErrorMessage: 'SubmitErrorMessage',
    formTitleMessage: 'Contact Details Page - Send Message To',
    contactFormPopupOpenedLabel: 'Accessibility label - Contact form pop-up opened',
    popupCloseBtnLabel: 'Accessibility label - Close button',
    browserNotSupported: 'Browser Not Supported',
};
